import React from 'react';
import { Menu } from 'react-admin';

const EmptyMenu = (props) => <Menu {...props} children={null} />;

export default EmptyMenu;
